import React, { useEffect, useState } from 'react';
import AtaRegistrationPriceSearchForm from 'components/molecules/ata_registration_price_search_form';
import AtaRegistrationPriceList from 'components/organisms/ata_registration_price_list';
import { getAtas, SearchAtas } from 'store/modules/ata_registration_price_store/actions';
import { useDispatch, useSelector } from 'react-redux';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { AtasState } from 'store/modules/ata_registration_price_store/types';

const AtaRegistrationPrice = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState<number>(1);
  const [search, setSearch] = useState<boolean>(false);
  const [params, setParams] = useState<any>();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { atas } = useSelector<ApplicationState, AtasState>((state) => state.session.atas);

  useEffect(() => {
    document.title = 'Ata de Registro de Preço - ConLicitação';
  }, []);

  useEffect(() => {
    search
      ? dispatch(SearchAtas(params, page))
      : dispatch(
          getAtas({
            page,
          }),
        );
  }, [page, search]);

  return (
    <div className="page-container">
      {atas?.atas_status === 'blocked_subscription' ? (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <AtaRegistrationPriceSearchForm
                setSearch={setSearch}
                setParams={setParams}
                setPage={setPage}
              />
            </div>
            <div className="col-md-9 pr-3 pr-md-0">
              <AtaRegistrationPriceList setPage={setPage} page={page} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export { AtaRegistrationPrice };
